// Department tabs of an item in Master data → Items (ADR-046): every
// department's data of an item in one place, unlike LN's item-purchase /
// item-sales / item-production sessions spread over the packages.

export const itemTabs = ["general", "purchasing", "sales", "warehousing", "production", "planning", "quality"] as const;
export type ItemTab = (typeof itemTabs)[number];

export const isItemTab = (v: unknown): v is ItemTab => typeof v === "string" && (itemTabs as readonly string[]).includes(v);
